import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { useParams } from "react-router-dom";
import useAuthUserToken from "../../hooks/useAuthUserToken";
import useGetFile from "../../hooks/useGetFile";
import { ReactLoading } from "../Dashboard/TinManagement/import";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";

function OpenResume() {
  const { path } = useParams();
  const decodePath = decodeURIComponent(path);
  const [ext, setExt] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");
  const { userToken } = useAuthUserToken();
  const { imageLoad, getImage } = useGetFile(userToken);

  useEffect(() => {
    const init = async () => {
      const pdfUrl = await getImage(decodePath);
      setResumeUrl(pdfUrl);
      setExt(decodePath?.split(".").pop().toLowerCase());
    };
    init();
  }, []);

  return (
    <>
      {imageLoad && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div style={{ height: "96vh", display: "flex", flexDirection: "column" }}>
        {ext === "pdf" && (
          <div style={{ flexGrow: 1 }}>
            <iframe
              style={{ width: "100%", height: "100vh" }}
              title="iframe"
              className="iframe"
              width="100%"
              height="100vh"
              src={resumeUrl}
            >
              <p>iframes are not supported by your browser.</p>
            </iframe>
          </div>
        )}
        {(ext?.toLowerCase() === "doc" || ext?.toLowerCase() === "docx") && (
          <div style={{ flexGrow: 1 }} className="resume">
            <DocViewer
              style={{ width: "100%" }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
              documents={[
                {
                  uri: resumeUrl,
                  fileType: ext,
                },
              ]}
            />
          </div>
        )}
        {(ext?.toLowerCase() === "png" ||
          ext?.toLowerCase() === "jpg" ||
          ext?.toLowerCase() === "jpeg" ||
          ext?.toLowerCase() === "jfif") && (
          <div
            style={{ flexGrow: 1 }}
            className="resume d-flex justify-content-center align-items-center"
          >
            <Image src={resumeUrl} />
          </div>
        )}
          {(ext?.toLowerCase() === "mp4") && (
          <div style={{ flexGrow: 1 }} className="resume d-flex justify-content-center align-items-center">
            <video controls src={resumeUrl}></video>
          </div>
        )}
      </div>
    </>
  );
}

export default OpenResume;
